// Display helpers for files and folders

export function formatSize(bytes) {
    if (!bytes) return '0 B'
    const units = ['B', 'KB', 'MB', 'GB', 'TB']
    const i = Math.min(units.length - 1, Math.floor(Math.log(bytes) / Math.log(1024)))
    return `${(bytes / Math.pow(1024, i)).toFixed(i ? 1 : 0)} ${units[i]}`
}

export function formatDate(iso) {
    return iso ? new Date(iso).toLocaleString() : ''
}

export function iconFor(node) {
    if (node.type === 'folder') return { icon: 'pi pi-folder', color: 'var(--p-primary-color)' }
    const mime = node.mime_type || ''
    if (mime.includes('pdf')) return { icon: 'pi pi-file-pdf', color: '#dc3545' }
    if (mime.includes('word') || mime.includes('opendocument.text')) return { icon: 'pi pi-file-word', color: '#0d6efd' }
    if (mime.includes('sheet') || mime.includes('excel') || mime.includes('csv')) return { icon: 'pi pi-file-excel', color: '#198754' }
    if (mime.startsWith('image/')) return { icon: 'pi pi-image', color: '#6f42c1' }
    if (mime.startsWith('video/')) return { icon: 'pi pi-video', color: '#fd7e14' }
    if (mime.startsWith('audio/')) return { icon: 'pi pi-volume-up', color: '#20c997' }
    if (mime.includes('zip') || mime.includes('compressed')) return { icon: 'pi pi-box', color: '#6c757d' }
    return { icon: 'pi pi-file', color: '#6c757d' }
}

// What the preview panel can show of a file
export function previewKind(node) {
    const mime = node?.mime_type || ''
    if (mime.startsWith('image/')) return 'image'
    if (mime === 'application/pdf') return 'pdf'
    if (mime.startsWith('video/')) return 'video'
    if (mime.startsWith('audio/')) return 'audio'
    if (mime.startsWith('text/') || ['application/json', 'application/xml'].includes(mime)) return 'text'
    return null
}
